export default __webpack_public_path__ + "static/media/SWT1790.34I-39825_-24216_0.cbac1c88.jpg";